import React from 'react';
import { useThemeUI } from 'theme-ui';

function ShareIcon() {
  const context = useThemeUI();
  const { theme } = context;
  const color = String(theme?.colors?.icons) || '#000';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M7.288 8.712a.491.491 0 010 .717.509.509 0 01-.717 0 2.526 2.526 0 010-3.57L8.36 4.072a2.526 2.526 0 013.57 0 2.526 2.526 0 010 3.57l-.753.752a3.486 3.486 0 00-.202-1.222l.237-.242a1.505 1.505 0 000-2.141 1.506 1.506 0 00-2.14 0L7.288 6.57a1.506 1.506 0 000 2.14zM8.712 6.57a.509.509 0 01.717 0 2.526 2.526 0 010 3.57l-1.787 1.787a2.526 2.526 0 01-3.57 0 2.526 2.526 0 010-3.57l.752-.752c-.005.414.06.828.202 1.227l-.237.237a1.506 1.506 0 000 2.141 1.506 1.506 0 002.14 0L8.713 9.43a1.506 1.506 0 000-2.141.491.491 0 010-.717z"
      />
    </svg>
  );
}

export default ShareIcon;
